import { render, staticRenderFns } from "./V2CartProducts.vue?vue&type=template&id=bac42aec&scoped=true&"
import script from "./V2CartProducts.vue?vue&type=script&lang=js&"
export * from "./V2CartProducts.vue?vue&type=script&lang=js&"
import style0 from "./V2CartProducts.vue?vue&type=style&index=0&id=bac42aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac42aec",
  null
  
)

export default component.exports